import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Magic.css';

const TELEGRAM_URL = 'https://t.me/justdisplay';

const Magic = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section className="magic" ref={ref}>
      <div className="magic-background">
        <div className="magic-gradient"></div>
      </div>
      
      <div className="magic-container">
        <motion.div
          className="magic-content"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 1 }}
        >
          <motion.h2
            className="magic-title"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Неотличимо от магии
          </motion.h2>

          <motion.div
            className="magic-description liquid-glass"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <p className="magic-text">
              Сенсорная панель с цифровым аватаром создаёт ощущение живого общения. 
              Интуитивно, экономично и технологично.
            </p>
            <p className="magic-text magic-text-secondary">
              Адаптивный ИИ на базе LLM. Полная кастомизация под вашу компанию без программирования.
            </p>
            <a
              href={TELEGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="magic-demo-button"
            >
              Посетить демонстрацию
            </a>
          </motion.div>

        </motion.div>

        <motion.div
          className="magic-visual"
          initial={{ opacity: 0, scale: 0.9, x: 50 }}
          animate={inView ? { opacity: 1, scale: 1, x: 0 } : {}}
          transition={{ duration: 1, delay: 0.6, ease: [0.6, -0.05, 0.01, 0.99] }}
        >
          <img 
            src="/images/cases/gari.jpeg" 
            alt="Цифровой аватар Гари"
            className="magic-avatar-image"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Magic;
